import EncryptUtility from "../../utility/js/encrypt-utility";
import AddFavourite from "../../utility/js/addFav";
import Utility from "../../../shared/utility";
import breadcrumbComp from "../../common/breadcrumb-comp.vue";
import router from "../../../router/router";
export default {
  data: () => ({
    userId: EncryptUtility.localStorageDecrypt("userID"),
    actionList: [],
    favouriteList: [],
    mainPage: "",
    subPage: "",
    backSlash: true,
    pageUrl: "",
    showAdd: false,
    refresh: true,
    searchStr: "",
    screenList: [],
    max200Rule: [(v) => (v || "").length <= 200 || "Max Length must be 200 characters or less"],
    screenHeaders: [
      { text: "Parent", align: "start", value: "Parent", class: "primary customwhite--text" },
      { text: "Sub-Menu", value: "Sub_Menu", class: "primary customwhite--text" },
      { text: "Screen Name", value: "Screen_Name", class: "primary customwhite--text" },
      { text: "URL", value: "URL", class: "primary customwhite--text" },
      { text: "Active", value: "Active", class: "primary customwhite--text" },
    ],
  }),
  async created() {
    this.route = this.$route.path.replace("/", "");
    let data = await AddFavourite.getPageAction(this.userId, this.route);
    this.actionList = data.actionList;
    this.mainPage = data.mainPage;
    this.favouriteList = data.favouriteList;
    this.pageUrl = data.pageUrl;
    this.subPage = data.subPage;
    this.showAdd = data.showAdd;
    if (EncryptUtility.localStorageDecrypt("RSMSearchText") !== null && EncryptUtility.localStorageDecrypt("RSMSearchText") !== undefined) {
      this.searchStr = EncryptUtility.localStorageDecrypt("RSMSearchText");
      this.searchSiteMap();
    } else {
      this.searchSiteMap();
    }
  },
  mounted() {
    router.afterEach((to) => {
      if (!to.path.includes("rlp-site-map") && !to.path.includes("rlp-site-map-details")) {
        EncryptUtility.localStorageRemoveItem("RSMSearchText");
      }
    });
  },
  methods: {
    resetFunction() {
      this.searchStr = "";
      this.screenList = [];
      this.searchSiteMap();
    },
    //Clear Search
    clearSearch() {
      this.searchStr = "";
      EncryptUtility.localStorageRemoveItem("RSMSearchText");
      this.searchSiteMap();
    },
    //Get Site Map Details
    searchSiteMap() {
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      let obj = {
        user_id: parseInt(this.userId),
        searchText: this.searchStr,
      };
      this.axios
        .post("/co/rlp_site_map", obj)
        .then((response) => {
          if (response.status == 200 || response.status == 204) {
            let responsedata = [];
            responsedata = JSON.parse(response.data.body.message);
            this.screenList = responsedata;
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          } else {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            let Alert = {
              type: "error",
              isShow: true,
              message: response.data.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        })
        .catch((error) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          let Alert = {
            type: "error",
            isShow: true,
            message: Utility.apiError(error),
          };
          this.$store.commit("ConfigModule/Alert", Alert);
          this.errorMessage = error.message;
        });
    },
    //Search Site
    searchSite() {
      this.searchStr = this.searchStr?.toUpperCase();
      if (this.searchStr !== null && this.searchStr !== undefined && this.searchStr !== "") {
        EncryptUtility.localStorageEncrypt("RSMSearchText", this.searchStr.toString());
      }
    },
    //Screen Details
    screenDetails(item) {
      this.$router.push({
        name: "rlpSiteMapDetails",
        params: {
          menuId: btoa(item.Page_Menu_Id.toString()),
          screenName: btoa(item.Screen_Name.toString()),
        },
      });
    },
  },
  components: {
    breadcrumbComp,
  },
};
